import React from "react";
import PropTypes from "prop-types";
import {
    AccountContextProvider,
    CombinedContextLoader,
    DocumentContextProvider,
    HeadingContextProvider,
    InstanceContextProvider,
    OrganisationContextProvider,
    ProjectContextProvider,
    WorkflowinstanceContextProvider
} from "partscatalog";

const ContextWrapper = ({
    children, context, instance, organisation, account, project, workflowinstance  
}) => {
    const {
        document, heading
    } = context || {};
    const documentId = project && document && !document.includes('-') && `${project}-${document}`;
    return (
        <OrganisationContextProvider organisation={organisation}>
            <AccountContextProvider account={account}>
                <InstanceContextProvider instance={instance}>
                    <ProjectContextProvider project={project}>
                        <DocumentContextProvider document={documentId}>
                            <WorkflowinstanceContextProvider workflowinstance={workflowinstance}>
                                <HeadingContextProvider heading={heading}>
                                    {children}
                                </HeadingContextProvider>
                            </WorkflowinstanceContextProvider>
                        </DocumentContextProvider>
                    </ProjectContextProvider>
                </InstanceContextProvider>
            </AccountContextProvider>
        </OrganisationContextProvider>
    );
};

ContextWrapper.defaultProps = {
    context: {},
    ...(CombinedContextLoader.defaultProps || {})
};

ContextWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    context: PropTypes.shape({
        project: PropTypes.string,
        document: PropTypes.string,
        heading: PropTypes.string,
    }),
    ...(CombinedContextLoader.propTypes || {})
};

const ContextGetter = props => {
    return (<CombinedContextLoader id="top-level-context-loader">
        <ContextWrapper {...props} />
    </CombinedContextLoader>);
};

export default ContextGetter;
